//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Detsky_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Detsky_info.vue